import { Chip, CSSObject, Theme } from '@mui/material'
import { sentenceCase } from 'change-case'

import { StatusChipProps } from './types'

export const StatusChip = <T extends string>({
  chipColors,
  status,
}: StatusChipProps<T>): React.JSX.Element => {
  return (
    <Chip
      label={sentenceCase(status)}
      size='small'
      sx={(theme: Theme): CSSObject => ({
        backgroundColor: chipColors(theme, status),
      })}
      variant='filledWhiteText'
    />
  )
}
